<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="80px" :model="form">
      <el-row>
        <el-form-item label="客户" style="margin-right:15px">
          <el-input v-model="form.shipmentName" :disabled="true" />
        </el-form-item>
        <el-form-item label="合同名称" style="margin-right:15px">
          <el-input v-model="form.name" :disabled="true" />
        </el-form-item>
        <el-form-item label="附件地址" style="margin-right:15px">
          <el-input v-model="form.contractPath" :disabled="true" />
        </el-form-item>
      </el-row>
      <el-row>
        <div class="grid-content bg-purple" style="margin:0 70px">
          <el-link :href="url" type="primary">
            查看上传文件
          </el-link>
        </div>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "ContractDetail",
  data() {
    return {
      url: "",
      emptyForm: {},
      form: {
        code: "",
        shipmentName: "",
        name: "",
        contractPath: "",
      },
    };
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      request({ url: `/ntocc-wms-api/contract/${code}`, method: "get" }).then(
        (response) => {
          this.form.name = response.data.entity.name;
          this.form.contractPath = response.data.entity.contractPath;
          this.form.shipmentName = response.data.entity.shipmentName;
          this.url = response.data.entity.contractPath;
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
</style>
